import React, { useState } from 'react';
import { Checkbox } from '@pmi/dsm-react';
import styles from './filterBy.module.scss';
import { Option } from '../../../../Admin/People/TabsCard/FilterBy';

export interface FilterZoneProps {
  selected?: string[];
  onChange: (selected: string[]) => void;
  list: Option[];
}

export default function FilterZoneSelection({
  selected = [],
  onChange,
  list,
}: FilterZoneProps) {
  const [selectZones, setSelectedZone] = useState<string[]>(selected);
  const isZoneSelected = (zone: string) => selectZones.includes(zone);
  const onZoneSelect = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    const zone = e.target.value;
    let clone = [...selectZones];
    if (checked) {
      clone.push(zone);
    } else {
      clone = clone.filter((z) => z !== zone);
    }
    setSelectedZone(clone);
    onChange(clone);
  };
  return (
    <div className="p-3 border-bottom mb-1">
      <h4>Zones</h4>
      <ul className={`${styles.filterOptionList} list-unstyled`}>
        {list.map((z, i) => (
          <li
            className={isZoneSelected(z.value) ? 'active' : ''}
            key={`zone-${i.toString()}`}
          >
            <Checkbox
              label={z.label}
              value={z.value}
              labelClass={styles.filterOption}
              onChange={onZoneSelect}
              checked={isZoneSelected(z.value)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
